module.exports = __webpack_public_path__ + "8e04dcf6.svg";